import React, { Component } from 'react';
import PropTypes from 'prop-types'
import moment from 'moment'

import fbIcon from '../static/img/facebook.png'
import twitterIcon from '../static/img/twitter.png'
import instagramIcon from '../static/img/instagram.png'

import bgText from "../static/img/footer-bg.png"
import ModalLayout from "./shared/ModalLayout"

class Footer extends Component {
	state = {
		showTOSModal: false
	}
	toggleModal = () => {
		this.setState(state => ({ showTOSModal: !state.showTOSModal }))
	}
	render() {
		let { t } = this.context
		let { lang } = this.props
		let { showTOSModal } = this.state
		let TOSLinks = {
			fr: "2PACX-1vTqQl91zg6JVbd2mpXNfEgevERISji8RFUhtoMGrdKigGvD20uxcKBoeAPuWbLo0rq0OOrO7GnBepif",
			nl: "2PACX-1vQpkhYaccnS2ny0A7A6_hMk-2KEgQwuGq4-NZiTI-M_NEpTCVrZ609i7ZZROjrPNAGq1pA5EPpc-35r",
			en: "2PACX-1vQ2PYceNQQocuOHiI39abSUWLWh8h2bCXeTOatJCrNv_NGnt4DOJ-xr1GZDHU-ylM27EbjiB9nrFAXU"
		}
		return(
			<div className="Footer">
				{showTOSModal &&
					<ModalLayout title={t('terms_of_service')} customClass="tos-modal" contentClass="g-doc-wrapper" closeModal={this.toggleModal}>
						<iframe title="tos" src={`https://docs.google.com/document/d/e/${TOSLinks[lang]}/pub?embedded=true`}></iframe>
					</ModalLayout>
				}
				<div className="content">
					<div className="first-title">{t('keep_up')}</div>
					<div className="second-title">{t('keep_up_prompt')}</div>
					<form
						id="mc-embedded-subscribe-form" className="mc_embed_signup" target="_blank" rel="noopener noreferrer"
						action="https://pootsy.us13.list-manage.com/subscribe/post?u=f19af7091871b8acbdf9f621e&amp;id=947a59df54"
						method="post" noValidate name="mc-embedded-subscribe-form"
					>
						<input type="email" name="EMAIL" className="email-input" placeholder={t("email_placeholder")} required />
						<input type="submit" value="" name="subscribe" id="mc-embedded-subscribe" className="submit-button-arrow"/>
					{/* --- Hidden input section --- */}
						<div style={{ position: "absolute", left: -5000 }} aria-hidden="true" >
							<input type="text" name="b_f19af7091871b8acbdf9f621e_947a59df54" tabIndex="-1" value=""/>
						</div>
					{/* --- Hidden input section --- */}
					</form>
					<div className="links">
						<a className="item" target="_blank" rel="noopener noreferrer" href="https://pro.pootsy.be">{t('pootsy_pro')}</a>
						<div className="item" onClick={this.toggleModal}>{t('cgu')}</div>
						<a className="item" href="mailto:press@pootsy.be">{t('press')}</a>
						<a className="item" href="mailto:hello@pootsy.be">{t('contact_us')}</a>
						<a className="item" target="_blank" rel="noopener noreferrer" href="https://medium.com/pootsy">{t('jobs')}</a>
					</div>
					<div className="social-links">
						<a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/pootsyapp/"><img alt="facebook" src={fbIcon}/></a>
						<a target="_blank" rel="noopener noreferrer" href="https://twitter.com/pootsyapp"><img alt="twitter" src={twitterIcon}/></a>
						<a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/pootsy.be/"><img alt="instagram" src={instagramIcon}/></a>
					</div>
					<div className="copyright">© {moment().year()} POOTSY</div>
				</div>
				<img className="text-bg" alt="bg-text" src={bgText}/>
			</div>
		)
	}
}

Footer.contextTypes = { t: PropTypes.func }
export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js